module.exports = __webpack_public_path__ + "static/media/dropdown_icon.1dd3e703.svg";